export const MachineHealthKpiOptionsText = {
  CheckValve: 'CheckValve',
  StrokeRate: 'StrokeRate',
  DecompValveTemperature: 'decompValveTemperature',
  PressureVessel: 'pressureVessel',
  MotorCurrent: 'MotorCurrent',
  MotorSpeed : 'MotorSpeed'
}